import { render, staticRenderFns } from "./Sbors.vue?vue&type=template&id=33df0184&scoped=true&"
import script from "./Sbors.vue?vue&type=script&lang=js&"
export * from "./Sbors.vue?vue&type=script&lang=js&"
import style0 from "./Sbors.vue?vue&type=style&index=0&id=33df0184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df0184",
  null
  
)

export default component.exports